import React from "react";

import { ReactComponent as AddIcon } from "images/icons/add.svg";
import { ReactComponent as SubtractIcon } from "images/icons/subtract.svg";

export const QuantityInput = ({
  onDecrement,
  onIncrement,
  onChangeQuantity,
  quantity,
  canDecrement,
  canIncrement,
  visibleOnZero,
  disabledButtons,
  } : {
  onDecrement: () => void;
  onIncrement: () => void;
  onChangeQuantity: (newVal: number) => void;
  quantity: number;
  canDecrement?: boolean;
  canIncrement?: boolean;
  visibleOnZero?: boolean;
  disabledButtons: boolean;
}) => {
  const changeQuantity = React.useCallback((event: React.ChangeEvent) => {
    const target = event.target as HTMLInputElement;
    const parsedValue = Number.parseInt(target.value);

    onChangeQuantity(Number.isNaN(parsedValue) ? 0 : parsedValue);
  }, [onChangeQuantity]);

  const decrement = canDecrement ?? true ? 
    <button
      className="button is-icon-only"
      type="button"
      name="decrement-button"
      disabled={disabledButtons}
      aria-label="Subtract"
      onClick={onDecrement}>
      <SubtractIcon className="icon streamline-icon" />
    </button> : null;

  const increment = <button
    className="button is-icon-only"
    type="button" 
    name="increment-button" 
    aria-label="Add"
    disabled={!(canIncrement ?? true) || disabledButtons}
    onClick={onIncrement}>
      <AddIcon className="icon streamline-icon" />
    </button>;

  const input = (quantity > 0 || (visibleOnZero ?? false)) && <input
    type="number"
    name="quantity-input"
    id="quantity-input"
    value={quantity}
    disabled={disabledButtons}
    onChange={changeQuantity}
  />;

  return (
    <div className="quantity-input">
      {decrement}
        <label htmlFor="quantity-input">Quantity</label>
        {input}
      {increment}
    </div>
  );
};

export default QuantityInput;
